import { Button } from 'components/Button/Button';
import css from './TaskForm.module.css';
import { useDispatch } from 'react-redux';
import { addTask } from 'redux/operation';
import Notiflix from 'notiflix';

export const TaskForm = () => {
  const dispatch = useDispatch();

  const handleSubmit = event => {
    event.preventDefault();
    const form = event.target;
    dispatch(addTask(form.elements.text.value));
    Notiflix.Notify.success(`Task added`);
    form.reset();
  };

  return (
    <form className={css.form} onSubmit={handleSubmit}>
      <input
        className={css.field}
        type="text"
        name="text"
        placeholder="Enter task text..."
      />
      <Button type="submit">Add task</Button>
    </form>
  );
};
